import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const LimityCiselnychRad = {
	name: NAME,
	apiProvider,
	router,
};
